

import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { Player, Position, defaultPlayer } from '@/views/interfaces/entities.ts';

import MatchBracket from './TournamentBrackets/MatchBracket.vue';
import PlayerInfo from './TournamentBrackets/PlayerInfo.vue';
import TournamentPosition from './TournamentBrackets/TournamentPosition.vue';

export default defineComponent({
  name: 'tournament-brackets',
  components: {
    MatchBracket,
    PlayerInfo,
    TournamentPosition,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      update: false,
    };
  },
  computed: {
    ...mapGetters({
      updateScreen: 'tournament/update',
      tournament: 'tournament/getTournament',
    }),
    tounamentSize8() {
      return true // this.tournament.size === 8;
    },
    tournamentSize16() {
      return false // this.tournament.size === 16;
    },
  },
  methods: {
    bracketWinner(pos: Position){
      if (pos === undefined) return '';
      const { player } = pos;
      if (player.id === undefined) return '';
      if(this.isDefaultPlayer(player)) return '';
      const leftChild = this.tournament.positions.find((position: Position) => position.id === pos.leftPos);
      const rightChild = this.tournament.positions.find((position: Position) => position.id === pos.rightPos);
      if (leftChild.player.id === undefined || rightChild.player.id === undefined || player === undefined) return '';
      if (leftChild.player.id === player.id) return 'top';
      if (rightChild.player.id === player.id) return 'bottom';
      return '';
    },
    isDefaultPlayer(player: Player): boolean {
      const { avatar, name } = player;
      const { avatar: defaultAvatar, name: defaultName } = defaultPlayer;
      return defaultAvatar === avatar && defaultName == name;
    }
  }
});
